import { FC } from "react";

import { SelectionEnum } from "@ryde/shared";

import { CheckboxControlledTstate } from "../../controls";
import { SelectCheckboxWrapperStyled } from "./select-options.styled";

export interface ISelectOptionsCheck {
  checked: SelectionEnum;
  setChecked: (opt: SelectionEnum) => void;
}

export const SelectOptionsCheck: FC<ISelectOptionsCheck> = ({
  checked,
  setChecked,
}) => {
  return (
    <SelectCheckboxWrapperStyled>
      <CheckboxControlledTstate checked={checked} setChecked={setChecked} />
    </SelectCheckboxWrapperStyled>
  );
};
